import App from './components/app.svelte';

const app = new App({
	target: document.body
});

export default app;